var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mw mx-auto"},[_c('Company',{staticClass:"mb-3",attrs:{"form":_vm.form}}),_c('FinancialInformation',{staticClass:"mb-3",attrs:{"form":_vm.form}}),_c('SupliersCreditors',{staticClass:"mb-3",attrs:{"form":_vm.form}}),_c('VehicleInfo',{staticClass:"mb-5",attrs:{"form":_vm.form}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }